import styled from 'styled-components';
import ggLogo from 'assets/gg-logo.png';

const FullLogo = styled.img.attrs(() => ({
    src: ggLogo
}))``;

export default FullLogo;



// WEBPACK FOOTER //
// ./src/components/atoms/FullLogo.js